export default __webpack_public_path__ + "static/shuttle_unavailable-c66488f62d6983bc69842397d9c30603.png";